/**
 * API Configuration
 *
 * Base URL for all API calls, resolved in this order:
 *   1. REACT_APP_API_BASE_URL  -> explicit override (set at build time)
 *   2. NODE_ENV === production  -> prod backend (api.prod.ts)
 *   3. otherwise                -> dev backend  (api.dev.ts)
 *
 * Defaults (no override):
 *   - `npm start`     -> dev backend
 *   - `npm run build` -> prod backend  (deploy to the prod S3 bucket)
 *
 * To build a dev-pointing production bundle (for the dev S3 bucket), override the URL:
 *   PowerShell:  $env:REACT_APP_API_BASE_URL='https://dev.terabase.services'; npm run build
 *   bash / CI:   REACT_APP_API_BASE_URL=https://dev.terabase.services npm run build
 *
 * To change a backend URL permanently, edit api.dev.ts / api.prod.ts (not this file).
 */
import { API_BASE_URL as DEV_API_BASE_URL, TERRAIN_PRO_APP_BASE_URL as DEV_APP_URL } from './api.dev';
import { API_BASE_URL as PROD_API_BASE_URL, TERRAIN_PRO_APP_BASE_URL as PROD_APP_URL } from './api.prod';

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === 'production' ? PROD_API_BASE_URL : DEV_API_BASE_URL);

// Base URL for the Terrain Pro web app — selected by the same env rule as API_BASE_URL,
// or overridden explicitly via REACT_APP_TERRAIN_PRO_APP_BASE_URL.
export const TERRAIN_PRO_APP_BASE_URL =
  process.env.REACT_APP_TERRAIN_PRO_APP_BASE_URL ||
  (process.env.NODE_ENV === 'production' ? PROD_APP_URL : DEV_APP_URL);
